function isPrivateIpv4(hostname) {
  const match = hostname.match(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/);
  if (!match) {
    return false;
  }
  const octets = match.slice(1).map(Number);
  if (octets.some((octet) => octet > 255)) {
    return false;
  }
  const [a, b] = octets;
  if (a === 10) {
    return true;
  }
  if (a === 192 && b === 168) {
    return true;
  }
  if (a === 172 && b >= 16 && b <= 31) {
    return true;
  }
  return false;
}

function isLocalHost(hostname = '') {
  const host = hostname.toLowerCase().replace(/:\d+$/, '');
  if (!host || host === 'localhost' || host === '127.0.0.1' || host === '::1' || host === '[::1]') {
    return true;
  }
  if (host.endsWith('.local')) {
    return true;
  }
  return isPrivateIpv4(host);
}

export function isDemo({
  demoFlag = process.env.REACT_APP_DEMO,
  nodeEnv = process.env.NODE_ENV,
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
} = {}) {
  if (demoFlag !== 'true') {
    return false;
  }
  if (nodeEnv === 'production') {
    return false;
  }
  if (!isLocalHost(hostname)) {
    return false;
  }
  return true;
}
